export default __webpack_public_path__ + "20ec3b1c02c17ca169ef07e16957e24b.png";